import axios from "axios";
import Vue from 'vue'
import store from '../index.js.erb'
import _ from "lodash";
import CommissionInteractionStatementsServices
    from '../../../components/application/statement_hostel/Services/Api/Commission/InteractionStatements'
import CommissionBasicInteractionStatementsServices
    from '../../../components/application/statement_hostel/Services/Api/Commission/BasicInteractionStatements'
import ProcessingStatement
    from '../../../components/application/statement_hostel/Services/Api/Pichers/ProcessingStatement'

const InteractionStatementStore = {
    namespaced: true,
    state: {
        curr_place_hostel: {},
        statement_hostel: {
            statement_hostel_type: '',
            array_place_hostel: [],
            gender: '',
            curr_phone_statement: '',
        },
        last_actual_statement: {},
        reject_comment: {
            statement_id: '',
            comment_type: [],
            comment_text: '',
        },
        dis_next_tab: true,
        activeTab: 0,
        show_statement_hostel: {},

        result_data_statements: {
            place: '',
            data_statement: [],
            data_request: []
        },

        list_distribution_hostel_statements: [],


        comments_statement: {},
        count_statements: '',
        tree_statements: {
            arr_states: []
        },
        hostel_orders: [],
        status_statements: true,
        status_circular: false,
        status_cr_order: {},
        stm_applicants: [],
        status_applicants_statements: true,
        get_stm_hostel: {},
        search_stm_hostel: {
            name: '',
            surname: '',
            patronymic: ''
        },


/////////////////////////////////////////////
        list_statements: [],
        details_data_stm_hostel_for_other_commission: {},
        status_conf: false,
        status_reject: false,
        status_get_details_statement: false,
        status_snackbar: false,
        errors: '',
/////////////////////////////////////////////
        comment_statement: {},
        list_current_statements: [],
        details_data_stm_hostel: {},
        list_distribution_statements: []
    },
    getters: {},
    mutations: {
        setNameHostel(state, {index_item: index_item, value: value}) {
            state.statement_hostel.array_place_hostel[index_item].name_hostel = value
        },
        setNameSection(state, {index_item: index_item, value: value}) {
            state.statement_hostel.array_place_hostel[index_item].name_section = value
        },
        setNameRoom(state, {index_item: index_item, value: value}) {
            state.statement_hostel.array_place_hostel[index_item].name_room = value
        },
        addArrayHostel(state) {
            state.statement_hostel.array_place_hostel.push({})

            let length_array_place_hostel = state.statement_hostel.array_place_hostel.length
            if (length_array_place_hostel < 4) {
                Vue.set(
                    state.statement_hostel.array_place_hostel[length_array_place_hostel - 1],
                    'name_hostel',
                    undefined
                )
                Vue.set(
                    state.statement_hostel.array_place_hostel[length_array_place_hostel - 1],
                    'name_section',
                    undefined
                )
                Vue.set(
                    state.statement_hostel.array_place_hostel[length_array_place_hostel - 1],
                    'name_room',
                    undefined
                )
            }
        },
        initStatement(state) {
            if (state.statement_hostel.array_place_hostel.length === 0) {
                state.statement_hostel.array_place_hostel.push({})

                Vue.set(
                    state.statement_hostel.array_place_hostel[0],
                    'name_hostel',
                    undefined
                )
                Vue.set(
                    state.statement_hostel.array_place_hostel[0],
                    'name_section',
                    undefined
                )
                Vue.set(
                    state.statement_hostel.array_place_hostel[0],
                    'name_room',
                    undefined
                )
            }
        },
        setStatementHostelType(state, statement_hostel_type) {
            state.statement_hostel.statement_hostel_type = statement_hostel_type
        },
        setLastActualStmHostel(state, last_actual_statement) {
            if (last_actual_statement) state.last_actual_statement = last_actual_statement
            else state.last_actual_statement = {}
        },
        setEditStatement(state) {
            state.statement_hostel.id_statement = state.show_statement_hostel.id
            state.statement_hostel.array_place_hostel = state.show_statement_hostel.place_hostel
            state.statement_hostel.gender = state.show_statement_hostel.gender
            state.statement_hostel.curr_phone_statement = state.show_statement_hostel.curr_phone
        },


        setStatementsPlace(state, statements) {
            if (statements.statement_hostels) state.result_data_statements.data_statement = statements.statement_hostels // Доработка подтягивания заявлений
        },
        setPlaceResData(state, place) {
            state.result_data_statements.place = place
        },
        setResDataStates(state, data_statement) {
            state.result_data_statements.data_statement = data_statement
        },
        setResetDataStates(state) {
            state.result_data_statements.data_statement = []
            state.result_data_statements.data_request = []
        },
        setResetDataRequest(state) {
            state.result_data_statements.data_request = []
        },
        setStatusConf(state, status_conf) {
            state.status_conf = status_conf
        },
        pushResDataStates(state, data_statement) {
            state.result_data_statements.data_statement.push(data_statement)
            state.result_data_statements.data_request.push(
                {
                    statement_hostel_id: data_statement.statement_hostel.id
                }
            )
        },
        deleteResDataStates(state, item) {
            let index_data_statement = _.findIndex(state.result_data_statements.data_statement, item)
            let index_data_request = _.findIndex(state.result_data_statements.data_request, {statement_hostel_id: item.statement_hostel.id})

            state.result_data_statements.data_statement[index_data_statement].statement_hostel.commission.dean_ex_work_confirm = 1
            state.result_data_statements.data_statement[index_data_statement].statement_hostel.result_place = ''

            state.result_data_statements.data_statement.splice(index_data_statement, 1)
            state.result_data_statements.data_request.splice(index_data_request, 1)
        },

        setListDistributionHostelStatements(state, list_distribution_hostel_statements) {
            state.list_distribution_hostel_statements = list_distribution_hostel_statements.statement_hostels
        },


        // setRegAdr(state, reg_adr){
        //     state.reg_adr = reg_adr
        // },
        removeItemHostel(state, item) {
            const index = state.statement_hostel.array_place_hostel.indexOf(item)
            if (index > 0) state.statement_hostel.array_place_hostel.splice(index, 1)
        },
        // setRating(state, rating){
        //     state.statement_hostel.rating = rating;
        // },
        setGender(state, gender) {
            localStorage.setItem('choice-gender', JSON.stringify(gender))
            state.statement_hostel.gender = gender
        },
        setCurrPhoneState(state, curr_phone_statement) {
            state.statement_hostel.curr_phone_statement = curr_phone_statement
        },
        showStatement(state, response) {
            if (response) state.show_statement_hostel = response
            else state.show_statement_hostel = {}
        },
        // showVerifStatement(state, response){
        //     state.show_verif_statements = response
        // },
        // indexVerifStatement(state, response){
        //     state.index_verif_statements = response
        // },
        visNextTab(state, bool) {
            state.dis_next_tab = bool
        },
        setActiveTab(state, activeTab) {
            state.activeTab = activeTab
        },
        deleteShowStatement(state) {
            state.show_statement_hostel = {}
            // Object.keys(state.show_statement_hostel).forEach(k => delete state.show_statement_hostel[k])
        },
        setStatusReject(state, status_reject) {
            state.status_reject = status_reject
        },
        setCommentStatement(state, comment) {
            state.reject_comment.comment_type = comment.categories
            state.reject_comment.comment_text = comment.text
        },
        setAllCommentsState(state, comments_statement) {
            state.comments_statement = comments_statement
        },
        setCurrPlaceHostel(state, curr_place_hostel) {
            state.curr_place_hostel = curr_place_hostel
        },
        setCommentStmHostel(state, comment_statement) {
            state.comment_statement = comment_statement
        },
        setCountStatements(state, count_statements) {
            state.count_statements = count_statements
        },
        setTreeStatements(state, tree_statements) {
            state.tree_statements.arr_states = tree_statements
        },

        setHostelOrders(state, hostel_orders) {
            state.hostel_orders = hostel_orders
        },
        formingStatementCircular(state, status_circular) {
            state.status_circular = status_circular
        },
        setStatusCrOrder(state, status_cr_order) {
            state.status_cr_order = status_cr_order
        },
        setStmApplicants(state, stm_applicants) {
            state.stm_applicants = stm_applicants
        },
        setStatusApplicantsStatements(state, status_applicants_statements) {
            state.status_applicants_statements = status_applicants_statements
        },
        setListStatements(state, list_statements) {
            state.list_statements = list_statements
        },
        setStatusListStatements(state, status_statements) {
            state.status_statements = status_statements
        },
        pushDopStatement(state) {
            store.state.list_statements.push(state.get_stm_hostel)
        },
        setListStatementsForDepartment(state, list_current_statements) {
            state.list_current_statements = list_current_statements
        },
        setDetailsDataStmHostel(state, details_data_stm_hostel) {
            state.details_data_stm_hostel = details_data_stm_hostel
        },
        setDetailsPlace(state, list_distribution_statements) {
            state.list_distribution_statements = list_distribution_statements
        },
        setDetailsDataStmHostelForOtherCommission(state, details_data_stm_hostel_for_other_commission) {
            state.details_data_stm_hostel_for_other_commission = details_data_stm_hostel_for_other_commission
        },
        setStatusSnackbar(state) {
            state.status_snackbar = !state.status_snackbar
        },
        setErrors(state, errors) {
            state.errors = errors
        }
    },
    actions: {
        NextTab({state, commit}) {
            commit('setActiveTab', state.activeTab + 1)
        },
        BackTab({state, commit}) {
            commit('setActiveTab', state.activeTab - 1)
        },
        //------------------------------Комиссия-------------------------------------------------------

        //----------------------Методы подающего заявления--------------------------------------------------
        async CreateStatement({state, commit, dispatch}) {
            commit('formingStatementCircular', true)
            const response = await ProcessingStatement.create(state.statement_hostel)
            dispatch('ShowStatement')
        },
        async ShowStatement({state, commit}) {
            const response = await ProcessingStatement.show()
            commit('formingStatementCircular', false)
            commit('showStatement', response.data)
        },
        async UpdateStatement({state, dispatch, commit}) {
            const response = await ProcessingStatement.update(state.show_statement_hostel.id, state.statement_hostel)
            dispatch('ShowStatement')
        },
        async RemoveStatement({state, commit}) {
            const response = await ProcessingStatement.delete(state.show_statement_hostel.id)
        },
        async LastActualStatement({state, commit}) {
            const response = await ProcessingStatement.get_last_actual_statement()
            commit('setLastActualStmHostel', response.data)
        },
        async GetAllCommentsStatement({state, commit}, statement_hostel_id) {
            const response = await ProcessingStatement.get_all_comment_statement(statement_hostel_id)
            commit('setAllCommentsState', response.data.commissions_comments)
        },
        async GetCurrPlaceHostel({state, commit}) {
            const response = await ProcessingStatement.get_curr_place_hostel()
            commit('setCurrPlaceHostel', response)
        },
        //---------------------------------------------------------------------------------------

        /////////////////////////Бухгалтер и УСБ/////////////////////////////////////////////

        async GetListStatements({state, commit}) {
            const response = await CommissionBasicInteractionStatementsServices.index()
            commit('setListStatements', response.data.statement_hostels)
            commit('setStatusListStatements', false)
        },
        async GetDetailsStatementForOtherCommission({state, commit}, statement_hostel_id) {
            state.status_get_details_statement = true
            const response = await CommissionBasicInteractionStatementsServices.show(statement_hostel_id)
            commit('setDetailsDataStmHostelForOtherCommission', response.data)
            state.status_get_details_statement = false
        },
        async ConfStatement({state, commit}, data_approbation) {
            const response = await CommissionBasicInteractionStatementsServices.update(
                data_approbation.statement_hostel_id,
                data_approbation.status_approbation
            )

            if (response.status === 200) {
                commit('setStatusConf', true)
            }
        },
        async RejectStatement({state, commit}, send_data) {
            const response = await CommissionBasicInteractionStatementsServices.update(
                send_data.data_approbation.statement_hostel_id,
                send_data.data_approbation.status_approbation,
                send_data.data_comment
            )

            if (response.status === 200) {
                commit('setStatusReject', true)
            }
        },
        async ShowCommentStatement({state, commit}, statement_hostel_id) {
            const response = await CommissionBasicInteractionStatementsServices.show_comment({statement_hostel_id: statement_hostel_id})
            commit('setCommentStmHostel', response.data)
        },

        ///////////////////////////Директор студтгородка///////////////////////////////

        async EvictionOfStudentFromRoom({state, commit, dispatch}, statement_hostel_id) {
            const response = await CommissionInteractionStatementsServices.delete(statement_hostel_id)
        },
        async CreateRecordDistributionPersonDepartment({state, commit, dispatch}, data_sending) {
            const response = await CommissionInteractionStatementsServices.create(data_sending)

            if (response?.data.hasOwnProperty("errors")) {
                commit('setStatusSnackbar')
                commit('setErrors', response.data.errors)
            }
        },
        async GetDetailsPlace({state, commit}, place_id) {
            const response = await CommissionInteractionStatementsServices.get_details_place({place_id: place_id})
            commit('setDetailsPlace', response.data.statement_hostels)
        },
        async GetDetailsStatement({state, commit}, stm_hostel_id) {
            const response = await CommissionInteractionStatementsServices.show(stm_hostel_id)
            commit('setDetailsDataStmHostel', response.data.statement_hostel)
        },
        async GetStatementsForDepartment({state, commit}, department_id) {
            const response = await CommissionInteractionStatementsServices.index({department_id: department_id})
            commit('setListStatementsForDepartment', response.data.statement_hostels)
        },
        async IndexApplicants({state, commit, dispatch}, department_id) {
            const response = await CommissionInteractionStatementsServices.get_applicants({department_id: department_id})
            commit('setStmApplicants', response.data)
            commit('setStatusApplicantsStatements', false)
        },
    }
}

export default InteractionStatementStore